import { userDefaultValuesTranslations as text } from './constants';
import { STATE } from 'app/constants';
import * as simpleFormActions from 'app/infrastructure/simple-form/actions';
import { createDescriptionSelector } from 'app/infrastructure/translate';
import { SuccessNotification, ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import {
  ProcessDefaultValuesFailed, ReceiveLoadDefaultValues, RequestLoadDefaultValues,
  ReceiveRole, FailRole, UpdateAccessData, RequestRole, FailLoadDefaultValues, ClearValidation,
  RequestSaveDefaultValues, ReceiveSaveDefaultValues, FailDefaultValuesExecute,
  ClearDefaultValuesData
} from './action-types';
import { api } from './api';
import { complexValidationFromServer } from 'app/infrastructure/data/validation';
import { AccessItem } from 'app/components/access-panel/shared/types';
import { errorSafe } from 'app/infrastructure/redux';
import { ActionDispatching } from 'app/types-shared';
import { ApplicationState } from 'app/types-store';
import { normalizeValidation } from 'app/components/access-panel/validation';

const simpleFormActionCreators = simpleFormActions.actionCreators(STATE.userDefaultValues);

export const actionCreators = {
  loadRole: (): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestRole());

      try {
        const role = await api.getRole();
        dispatch(new ReceiveRole({ defaultValues: role.data }));
      } catch (err) {
        dispatch(new FailRole());
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
      }
    },

  loadDefaultValues: (): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {
      try {
        dispatch(new RequestLoadDefaultValues());

        const result = await api.getDefaultValues();

        dispatch(new ReceiveLoadDefaultValues({ defaultValues: result.data }));
      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
        dispatch(new FailLoadDefaultValues());
      }
    },

  saveDefaultValues: (query, onSucces: () => void): ActionDispatching<any, any> =>
    async (dispatch: any, getState: () => ApplicationState) => {
      const translate = createDescriptionSelector(getState().userDefaultValues.texts);

      try {
        dispatch(new RequestSaveDefaultValues());
        const result = await api.saveDefaultValues(query) as any;

        if (result) {
          dispatch(new ReceiveSaveDefaultValues());
          dispatch(new SuccessNotification(translate(text.updated_default_values)));
          onSucces();
        }
      } catch (err) {
        dispatch(new FailDefaultValuesExecute());
        dispatch(new ErrorNotification(translate(text.validation_error)));
        dispatch(new ProcessDefaultValuesFailed(err.validationErrors
          ? complexValidationFromServer(normalizeValidation(err.validationErrors, { defaultValues: query })) : []));
      }
    },

  updateAccessData: (key: string, accessItem: Partial<AccessItem>): ActionDispatching<any, any> =>
    async (dispatch: any, getState: () => ApplicationState) => {
      dispatch(new UpdateAccessData(key, accessItem));
    },

  clearValidation: (formName: string, parameters?: { [key: string]: number | string }): ActionDispatching<any, any> =>
    async (dispatch: any, getState: () => ApplicationState) => {
      dispatch(new ClearValidation(formName, parameters));
    },

  clearValueInStore: (id: string): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {
      dispatch(simpleFormActionCreators.clearValueInStore(id));
    }),

  clearDefaultValues: (): ActionDispatching<any, any> => async (dispatch: any, getState: any) => {
    dispatch(new ClearDefaultValuesData());
  }
};
